/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from 'antd';
import { reportApis } from 'Api/reports';
import { PermissionContext } from 'components/Global/AuthLayout';
import Buttons from 'components/Global/Buttons';
import { TablePagination, TableSorter } from 'interfaces/global.interface';
import { useContext, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import GlobalReportTable from '../GlobalReportTable';
import GenerateP13Modal from './GenerateP13Modal';
import Styles from './index.module.scss';

const P13ReportComponent = () => {
	const [totalRecords, setTotalRecords] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState('');
	const [sortOrder, setSortOrder] = useState('');
	const [modalOpen, setModalOpen] = useState(false);
	const [reportData, setReportData] = useState<any[]>([]);

	const context = useContext(PermissionContext);
	const check = context.allowedPermissions.includes('Add_Payroll_Reports');

	const { Text } = Typography;
	const buttons = [
		{
			text: 'Generate',
			isLoading: false,
			className: 'btn-blue',
			isSubmit: true,
			onclick: () => {
				setModalOpen(true);
			},
			disabled: isLoading,
		},
	];

	const tableChangeHandler = (
		pagination: TablePagination,
		filters: any,
		sorter: TableSorter
	) => {
		setTotalRecords(pagination.total);
		setCurrentPage(pagination.current);
		setPageSize(pagination.pageSize);
		let order = '';
		if (sorter?.order === 'ascend') {
			order = 'asc';
		} else if (sorter?.order) {
			order = 'desc';
		}
		setSortOrder(order);
		setSortField(sorter.field);
	};

	const cancelModal = () => {
		setModalOpen(false);
	};

	const fetchReportDetails = async () => {
		try {
			const query = {
				page: currentPage,
				sortBy: sortField,
				sortOrder: sortOrder,
				pageSize: pageSize,
			};
			setIsLoading(true);
			const p13Data = await reportApis.getP13Reports(query);
			setReportData(p13Data.data.data);
			setTotalRecords(p13Data.data.total);
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching P13 reports';
			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchReportDetails();
	}, [currentPage, sortField, sortOrder, pageSize]);

	return (
		<>
			<div className={Styles['container']}>
				<div className={Styles['P13-header']}>
					<Text style={{ marginRight: '15px', color: '#444' }}>
						Generate a combined P13 (Particulars of Employee Leaving)
						form for employees whose tenure ended in the selected pay
						period.
					</Text>
					{check && <Buttons buttons={buttons} />}
				</div>
				<GlobalReportTable
					ReportData={reportData}
					isLoading={isLoading}
					tableChangeHandler={tableChangeHandler}
					totalRecords={totalRecords}
					pageSize={pageSize}
					currentPage={currentPage}
					variant="default"
				/>
			</div>
			{modalOpen && (
				<GenerateP13Modal
					open={modalOpen}
					cancelGenerateModal={cancelModal}
					fetchReportDetails={fetchReportDetails}
				/>
			)}
		</>
	);
};

export default P13ReportComponent;
